export const GoogleIcon = (props) => (
  <svg fill="none" height={32} viewBox="0 0 32 32" width={32} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M30.08 16.3335C30.08 15.2935 29.9867 14.2935 29.8133 13.3335H16V19.0135H23.8933C23.5467 20.8402 22.5067 22.3868 20.9467 23.4268V27.1202H25.7067C28.48 24.5602 30.08 20.8002 30.08 16.3335Z"
      fill="#4285F4"
    />
    <path
      d="M15.9996 30.6667C19.9596 30.6667 23.2796 29.36 25.7062 27.12L20.9462 23.4267C19.6396 24.3067 17.9729 24.84 15.9996 24.84C12.1862 24.84 8.94625 22.2667 7.78625 18.8H2.90625V22.5867C5.31958 27.3734 10.2662 30.6667 15.9996 30.6667Z"
      fill="#34A853"
    />
    <path
      d="M7.78537 18.7865C7.49203 17.9065 7.3187 16.9732 7.3187 15.9998C7.3187 15.0265 7.49203 14.0932 7.78537 13.2132V9.42651H2.90536C1.90536 11.3998 1.33203 13.6265 1.33203 15.9998C1.33203 18.3732 1.90536 20.5998 2.90536 22.5732L6.70537 19.6132L7.78537 18.7865Z"
      fill="#FBBC05"
    />
    <path
      d="M15.9996 7.1735C18.1596 7.1735 20.0796 7.92016 21.6129 9.36016L25.8129 5.16016C23.2663 2.78683 19.9596 1.3335 15.9996 1.3335C10.2662 1.3335 5.31958 4.62683 2.90625 9.42683L7.78625 13.2135C8.94625 9.74683 12.1862 7.1735 15.9996 7.1735Z"
      fill="#EA4335"
    />
  </svg>
);
